// Full-document render of the tempurpedic MattressFilterListPage: PageSkeleton
// (the React document shell) around the entire body -- one
// `.mattress-modules` div wrapping the `modules` stream (Fragment mode, no
// per-block `w-block-*` wrappers). This page has no hero of any kind (normal
// site chrome, no header/footer/body_class overrides).
import { Immutable } from "immer";
import React from "react";
import { CompatibilityAccordion } from "tsi-common-react/src/components/CompatibilityAccordion/index";

import { templates } from "@reactivated";
import type { CompatibilityAccordionModule as CompatibilityAccordionValue } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { buildToolboxPageMap } from "../blocks/toolboxPageMap";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.MattressFilterListPageTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    const modules = props.page.modules;
    const components = {
        ...buildToolboxPageMap(props),
        // `compatibility` is scoped to MattressFilterListPageBodyContent (and
        // the PDP assemblies) rather than the shared Toolbox, so the shared
        // page map has no entry. The themed `<section>` wrapper and the
        // panels gate must live HERE, not in the component: the dispatcher
        // reaches CompatibilityAccordion raw, with no wrapper of its own, and
        // the accordion should only render when panels exist.
        compatibility: (block: {
            value: Immutable<CompatibilityAccordionValue>;
        }) => (
            <section className={block.value.background_style.style}>
                {block.value.compatibility_panels.length > 0 && (
                    <CompatibilityAccordion value={block.value} />
                )}
            </section>
        ),
    };
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="mattress-modules">
                {modules && (
                    <StreamField
                        tagName={React.Fragment}
                        value={modules.value}
                        components={components}
                    />
                )}
            </div>
        </PageSkeleton>
    );
};
